import api from '.';

const userOrgRolesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createUserOrganizationsRoles: builder.mutation({
      query: (params) => ({
        url: `/users/${params?.user_id}/organizations/${params?.organization_id}/assign-role/${params?.role_id}`,
        method: 'POST'
      })
    }),

    updateUserOrganizationsRoles: builder.mutation({
      query: (params) => ({
        url: `/user-organization-role/${params.id}/users/${params?.user_id}/organizations/${params?.organization_id}/role/${params?.role_id}`,
        method: 'PATCH'
      })
    }),
    deleteUserOrganizationsRole: builder.mutation({
      query: ({ id }) => ({
        url: `/user-organization-roles/${id}`,
        method: 'DELETE'
      })
    }),
    createSuperAdminRole: builder.mutation({
      query: (params) => {
        return {
          url: `/users/${params.userId}/create-role/${params.roleId}`,
          method: 'POST'
        };
      }
    })
  })
});
export default userOrgRolesApi;

export const {
  useCreateUserOrganizationsRolesMutation,
  useUpdateUserOrganizationsRolesMutation,
  useDeleteUserOrganizationsRoleMutation,
  useCreateSuperAdminRoleMutation
} = userOrgRolesApi;
